/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as RoutesRouteImport } from './routes/routes'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as PlannerRouteImport } from './routes/planner'
import { Route as ItineraryRouteImport } from './routes/itinerary'
import { Route as FlightsRouteImport } from './routes/flights'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as ExperiencesRouteImport } from './routes/experiences'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CuentaRouteImport } from './routes/cuenta'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as AfiliadosRouteImport } from './routes/afiliados'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DestinationIataRouteImport } from './routes/destination.$iata'
import { Route as ComingSoonVerticalRouteImport } from './routes/coming-soon.$vertical'

const TerminosRoute = TerminosRouteImport.update({
  id: '/terminos',
  path: '/terminos',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutesRoute = RoutesRouteImport.update({
  id: '/routes',
  path: '/routes',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadRoute = PrivacidadRouteImport.update({
  id: '/privacidad',
  path: '/privacidad',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerRoute = PlannerRouteImport.update({
  id: '/planner',
  path: '/planner',
  getParentRoute: () => rootRouteImport,
} as any)
const ItineraryRoute = ItineraryRouteImport.update({
  id: '/itinerary',
  path: '/itinerary',
  getParentRoute: () => rootRouteImport,
} as any)
const FlightsRoute = FlightsRouteImport.update({
  id: '/flights',
  path: '/flights',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreRoute = ExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperiencesRoute = ExperiencesRouteImport.update({
  id: '/experiences',
  path: '/experiences',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CuentaRoute = CuentaRouteImport.update({
  id: '/cuenta',
  path: '/cuenta',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactoRoute = ContactoRouteImport.update({
  id: '/contacto',
  path: '/contacto',
  getParentRoute: () => rootRouteImport,
} as any)
const AfiliadosRoute = AfiliadosRouteImport.update({
  id: '/afiliados',
  path: '/afiliados',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DestinationIataRoute = DestinationIataRouteImport.update({
  id: '/destination/$iata',
  path: '/destination/$iata',
  getParentRoute: () => rootRouteImport,
} as any)
const ComingSoonVerticalRoute = ComingSoonVerticalRouteImport.update({
  id: '/coming-soon/$vertical',
  path: '/coming-soon/$vertical',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/afiliados': typeof AfiliadosRoute
  '/contacto': typeof ContactoRoute
  '/cookies': typeof CookiesRoute
  '/cuenta': typeof CuentaRoute
  '/dashboard': typeof DashboardRoute
  '/experiences': typeof ExperiencesRoute
  '/explore': typeof ExploreRoute
  '/flights': typeof FlightsRoute
  '/itinerary': typeof ItineraryRoute
  '/planner': typeof PlannerRoute
  '/privacidad': typeof PrivacidadRoute
  '/reset-password': typeof ResetPasswordRoute
  '/routes': typeof RoutesRoute
  '/terminos': typeof TerminosRoute
  '/coming-soon/$vertical': typeof ComingSoonVerticalRoute
  '/destination/$iata': typeof DestinationIataRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/afiliados': typeof AfiliadosRoute
  '/contacto': typeof ContactoRoute
  '/cookies': typeof CookiesRoute
  '/cuenta': typeof CuentaRoute
  '/dashboard': typeof DashboardRoute
  '/experiences': typeof ExperiencesRoute
  '/explore': typeof ExploreRoute
  '/flights': typeof FlightsRoute
  '/itinerary': typeof ItineraryRoute
  '/planner': typeof PlannerRoute
  '/privacidad': typeof PrivacidadRoute
  '/reset-password': typeof ResetPasswordRoute
  '/routes': typeof RoutesRoute
  '/terminos': typeof TerminosRoute
  '/coming-soon/$vertical': typeof ComingSoonVerticalRoute
  '/destination/$iata': typeof DestinationIataRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/afiliados': typeof AfiliadosRoute
  '/contacto': typeof ContactoRoute
  '/cookies': typeof CookiesRoute
  '/cuenta': typeof CuentaRoute
  '/dashboard': typeof DashboardRoute
  '/experiences': typeof ExperiencesRoute
  '/explore': typeof ExploreRoute
  '/flights': typeof FlightsRoute
  '/itinerary': typeof ItineraryRoute
  '/planner': typeof PlannerRoute
  '/privacidad': typeof PrivacidadRoute
  '/reset-password': typeof ResetPasswordRoute
  '/routes': typeof RoutesRoute
  '/terminos': typeof TerminosRoute
  '/coming-soon/$vertical': typeof ComingSoonVerticalRoute
  '/destination/$iata': typeof DestinationIataRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/afiliados'
    | '/contacto'
    | '/cookies'
    | '/cuenta'
    | '/dashboard'
    | '/experiences'
    | '/explore'
    | '/flights'
    | '/itinerary'
    | '/planner'
    | '/privacidad'
    | '/reset-password'
    | '/routes'
    | '/terminos'
    | '/coming-soon/$vertical'
    | '/destination/$iata'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/afiliados'
    | '/contacto'
    | '/cookies'
    | '/cuenta'
    | '/dashboard'
    | '/experiences'
    | '/explore'
    | '/flights'
    | '/itinerary'
    | '/planner'
    | '/privacidad'
    | '/reset-password'
    | '/routes'
    | '/terminos'
    | '/coming-soon/$vertical'
    | '/destination/$iata'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/afiliados'
    | '/contacto'
    | '/cookies'
    | '/cuenta'
    | '/dashboard'
    | '/experiences'
    | '/explore'
    | '/flights'
    | '/itinerary'
    | '/planner'
    | '/privacidad'
    | '/reset-password'
    | '/routes'
    | '/terminos'
    | '/coming-soon/$vertical'
    | '/destination/$iata'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AfiliadosRoute: typeof AfiliadosRoute
  ContactoRoute: typeof ContactoRoute
  CookiesRoute: typeof CookiesRoute
  CuentaRoute: typeof CuentaRoute
  DashboardRoute: typeof DashboardRoute
  ExperiencesRoute: typeof ExperiencesRoute
  ExploreRoute: typeof ExploreRoute
  FlightsRoute: typeof FlightsRoute
  ItineraryRoute: typeof ItineraryRoute
  PlannerRoute: typeof PlannerRoute
  PrivacidadRoute: typeof PrivacidadRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RoutesRoute: typeof RoutesRoute
  TerminosRoute: typeof TerminosRoute
  ComingSoonVerticalRoute: typeof ComingSoonVerticalRoute
  DestinationIataRoute: typeof DestinationIataRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terminos': {
      id: '/terminos'
      path: '/terminos'
      fullPath: '/terminos'
      preLoaderRoute: typeof TerminosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routes': {
      id: '/routes'
      path: '/routes'
      fullPath: '/routes'
      preLoaderRoute: typeof RoutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidad': {
      id: '/privacidad'
      path: '/privacidad'
      fullPath: '/privacidad'
      preLoaderRoute: typeof PrivacidadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planner': {
      id: '/planner'
      path: '/planner'
      fullPath: '/planner'
      preLoaderRoute: typeof PlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/itinerary': {
      id: '/itinerary'
      path: '/itinerary'
      fullPath: '/itinerary'
      preLoaderRoute: typeof ItineraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flights': {
      id: '/flights'
      path: '/flights'
      fullPath: '/flights'
      preLoaderRoute: typeof FlightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiences': {
      id: '/experiences'
      path: '/experiences'
      fullPath: '/experiences'
      preLoaderRoute: typeof ExperiencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cuenta': {
      id: '/cuenta'
      path: '/cuenta'
      fullPath: '/cuenta'
      preLoaderRoute: typeof CuentaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacto': {
      id: '/contacto'
      path: '/contacto'
      fullPath: '/contacto'
      preLoaderRoute: typeof ContactoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/afiliados': {
      id: '/afiliados'
      path: '/afiliados'
      fullPath: '/afiliados'
      preLoaderRoute: typeof AfiliadosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/destination/$iata': {
      id: '/destination/$iata'
      path: '/destination/$iata'
      fullPath: '/destination/$iata'
      preLoaderRoute: typeof DestinationIataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coming-soon/$vertical': {
      id: '/coming-soon/$vertical'
      path: '/coming-soon/$vertical'
      fullPath: '/coming-soon/$vertical'
      preLoaderRoute: typeof ComingSoonVerticalRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AfiliadosRoute: AfiliadosRoute,
  ContactoRoute: ContactoRoute,
  CookiesRoute: CookiesRoute,
  CuentaRoute: CuentaRoute,
  DashboardRoute: DashboardRoute,
  ExperiencesRoute: ExperiencesRoute,
  ExploreRoute: ExploreRoute,
  FlightsRoute: FlightsRoute,
  ItineraryRoute: ItineraryRoute,
  PlannerRoute: PlannerRoute,
  PrivacidadRoute: PrivacidadRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RoutesRoute: RoutesRoute,
  TerminosRoute: TerminosRoute,
  ComingSoonVerticalRoute: ComingSoonVerticalRoute,
  DestinationIataRoute: DestinationIataRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
